export const EMPLOYEE_LIST = [
    //data for admin section
    {
        id: "0001",
        name: "Newton Newstart",
        email: "newbie@cubewraps.com",
        phoneNumber: "0000000000",
        employeeStatus: "CURRENT",
        jobTitle: "Admin staff",
        dates: {
            dateStarted: "16/03/2023",
            dateEnded: "null",
        },
        jobs: [],
        popup: "Current Employee"
    },

    {
        id: "0002",
        name: "Amy Smith",
        email: "amysmith@cubewraps.com",
        phoneNumber: "0000000000",
        employeeStatus: "CURRENT",
        jobTitle: "Admin staff",
        dates: {
            dateStarted: "09/02/2023",
            dateEnded: "null",
        },
        jobs: ["0001"],
        popup: "Current Employee"
    },

    {
        id: "0003",
        name: "Thomas Doe",
        email: "thomasd@cubewraps.com",
        phoneNumber: "0000000000",
        employeeStatus: "CURRENT",
        jobTitle: "Design staff",
        dates: {
            dateStarted: "09/08/2022",
            dateEnded: "null",
        },
        jobs: [],
        popup: "Current Employee"
    },

    {
        id: "0004",
        name: "Issac Ink",
        email: "inky@cubewraps.com",
        phoneNumber: "0000000000",
        employeeStatus: "CURRENT",
        jobTitle: "Printing staff",
        dates: {
            dateStarted: "09/08/2022",
            dateEnded: "null",
        },
        jobs: ["0010", "0002", "0006", "0007", "0003"],
        popup: "Current Employee"
    },

    {
        id: "0005",
        name: "Scott Smith",
        email: "scotty@cubewraps.com",
        phoneNumber: "0000000000",
        employeeStatus: "CURRENT",
        jobTitle: "Installation staff",
        dates: {
            dateStarted: "09/08/2022",
            dateEnded: "null",
        },
        jobs: ["0005", "0001"],
        popup: "Current Employee"
    },

    {
        id: "0006",
        name: "Carolann Smile",
        email: "thomasd@cubewraps.com",
        phoneNumber: "0000000000",
        employeeStatus: "CURRENT",
        jobTitle: "Management staff",
        dates: {
            dateStarted: "09/08/2022",
            dateEnded: "null",
        },
        jobs: ["0001", "0002", "0003", "0004", "0005", "0006", "0007", "0008", "0009"],
        popup: "Current Employee"
    },

    {
        id: "0007",
        name: "Josh McJobless",
        email: "jobless@cubewraps.com",
        phoneNumber: "0000000000",
        employeeStatus: "EX",
        jobTitle: "Admin staff",
        dates: {
            dateStarted: "09/06/2022",
            dateEnded: "10/12/2022"
        },
        jobs: ["0003", "0009", "0004", "0005", "0001"],
        popup: "Ex-Employee"
    },

    {
        id: "0008",
        name: "Una Unemployed",
        email: "unau@cubewraps.com",
        phoneNumber: "0000000000",
        employeeStatus: "EX",
        jobTitle: "Design staff",
        dates: {
            dateStarted: "09/06/2022",
            dateEnded: "10/12/2022"
        },
        jobs: ["0003", "0001", "0010"],
        popup: "Ex-Employee"
    },
]